import { render, staticRenderFns } from "./ResultMonitorRatings.vue?vue&type=template&id=559995fb&scoped=true"
import script from "./ResultMonitorRatings.vue?vue&type=script&lang=js"
export * from "./ResultMonitorRatings.vue?vue&type=script&lang=js"
import style0 from "./ResultMonitorRatings.vue?vue&type=style&index=0&id=559995fb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559995fb",
  null
  
)

export default component.exports